/**
 * dialog 弹窗 拖拽
 *
 */

import Vue from 'vue';

function convert(value, isHeight) {
  if (value.includes('%')) {
    return (
      +document.body[isHeight ? 'clientHeight' : 'clientWidth'] *
      (+value.replace(/%/g, '') / 100)
    );
  }
  return +value.replace(/\px/g, '');
}

Vue.directive('drag', {
  bind(el, binding) {
    const { arg } = binding;

    let dragDom;
    let dialogHeaderEl;

    if (arg === 'common') {
      el.style.overflow = 'hidden';
      dragDom = el.querySelector('.el-dialog');
      dialogHeaderEl = el.querySelector('.el-dialog__header');
    } else if (arg) {
      dragDom = el;
      dialogHeaderEl = el;
    } else {
      dragDom = el;
      dialogHeaderEl = el.querySelector('.el-dialog__header');
    }

    // const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle  火狐谷歌 window.getComputedStyle(dom元素, null);
    // const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
    const yName = arg === 'bottom' ? 'bottom' : 'top';

    dialogHeaderEl.onmousedown = e => {
      // 鼠标按下，计算当前元素距离可视区的距离
      // const disX = e.clientX - dialogHeaderEl.offsetLeft;
      // const disY = e.clientY - dialogHeaderEl.offsetTop;
      const startX = e.clientX;
      const startY = e.clientY;
      const originX = convert(dragDom.style.left, false);
      const originY = convert(dragDom.style[yName], true);

      // // 获取到的值带px 正则匹配替换
      // let styL, styT;

      // // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      // if (sty.left.includes('%')) {
      //   styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100);
      //   styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100);
      // } else {
      //   styL = +sty.left.replace(/\px/g, '');
      //   styT = +sty.top.replace(/\px/g, '');
      // }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - startX;
        const t = (e.clientY < 85 ? 85 : e.clientY) - startY;

        // 移动当前元素
        dragDom.style.left = `${l + originX}px`;
        const diff = arg === 'bottom' ? -t : t;
        dragDom.style[yName] = `${diff + originY}px`;
      };

      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
